export const JobsActionTypes = {
  PerformOperation: 'PERFORM_OPERTAION',
  PerformOperationSuccess: 'PERFORM_OPERTAION_SUCCESS',
  PerformOperationError: 'PERFORM_OPERTAION_ERROR',
  GetSimilarOperationIds: 'GET_SIMILAR_OPERATION_IDS',
  GetSimilarOperationIdsSuccess: 'GET_SIMILAR_OPERATION_IDS_SUCCESS',
  GetSimilarOperationIdsError: 'GET_SIMILAR_OPERATION_IDS_ERROR',
};
